import { Document, UserProfile } from "../../models";
import { UsersState } from "../../redux";
import { GetCollectionByGroupUid } from "../getCollection/getCollectionByGroupUid";

export type PotentialMemberRole = 'author' | 'member' | 'none'

export interface PotentialMemberResult {
    user: UserProfile
    currentRole: PotentialMemberRole
}

export const getAllPotentialMembersForDocument = (getCollectionByGroupUid: GetCollectionByGroupUid, usersState: UsersState, allUsersState?: UsersState) =>
    (document: Document): PotentialMemberResult[] => {
        const authorFromAll = (allUsersState?.data ?? []).find(x => x.auth0_id === document.userUUID)
        const authorWasRemoved = authorFromAll?.status === 5
    
        const author = authorWasRemoved ? authorFromAll : usersState.data.find(x => x.auth0_id === document.userUUID)
        if (!author) {
            return []
        }
        const authorMemberResult: PotentialMemberResult = {
            currentRole: 'author',
            user: author
        }

        const otherMembersProfiles: UserProfile[] = document.members.filter(x => x.userUUID !== author.auth0_id)
            .map(member => usersState.data.find(x => x.auth0_id === member.userUUID))
            .filter(x => x) as UserProfile[]
        const members: PotentialMemberResult[] = otherMembersProfiles.map(mapToPossibleMemberResult('member'))

        let otherPossibleMembers: PotentialMemberResult[] = []
        const authorAndMembersUUIDs = [author.auth0_id, ...otherMembersProfiles.map(x => x.auth0_id)]
        const restOfUsersInOrganization = usersState.data.filter(user => !authorAndMembersUUIDs.includes(user.auth0_id))
        const restOfUsersInOrganizationMemberResult: PotentialMemberResult[] = restOfUsersInOrganization.map(mapToPossibleMemberResult('none'))

        if (document.groupUid) {
            const collection = getCollectionByGroupUid(document.groupUid)
            if (collection && collection.collectionGroup.isClosed) {
                const groupUsers = collection.collectionGroup.groupUsers
                const limitedUsers = collection.limitedGroup.groupUsers
                const allUsers = groupUsers.concat(limitedUsers);
                const groupUsersThatArentAuthorsOrMembers = allUsers.filter(x => x.status === 0 && !authorAndMembersUUIDs.includes(x.auth0_id))
                otherPossibleMembers = groupUsersThatArentAuthorsOrMembers.map(mapToPossibleMemberResult('none'))
            } else if(collection && !collection.collectionGroup.isClosed) {
                
                const needDTOGroupUsers = isNeedDTOForMembers(collection?.collectionGroup?.groupUsers ?? [])
                const groupUsers = !needDTOGroupUsers ? collection?.collectionGroup?.groupUsers ?? [] : dtoForMembers(collection?.collectionGroup?.groupUsers ?? [], usersState.data)

                const needDTOLimitedUsers = isNeedDTOForMembers(collection?.limitedGroup?.groupUsers ?? [])
                const limitedUsers = needDTOLimitedUsers ? collection?.limitedGroup?.groupUsers ?? [] : dtoForMembers(collection?.limitedGroup?.groupUsers ?? [], usersState.data)

                const allUsers = groupUsers.concat(limitedUsers);
                const groupUsersThatArentAuthorsOrMembers = allUsers.filter(x => x.status === 0 && !authorAndMembersUUIDs.includes(x.auth0_id))
                otherPossibleMembers = groupUsersThatArentAuthorsOrMembers.map(mapToPossibleMemberResult('none'))
            }
        } else {
            otherPossibleMembers = restOfUsersInOrganizationMemberResult
        }

        const authorArr = authorWasRemoved ? [] : [authorMemberResult]
        return [...authorArr, ...members, ...otherPossibleMembers]
    }

const mapToPossibleMemberResult = (role: PotentialMemberRole) => (user: UserProfile): PotentialMemberResult => ({
    currentRole: role,
    user
})

//@ts-ignore
const isNeedDTOForMembers = (groupUsers: UserProfile[]) => groupUsers.some(member => !member.auth0_id && !!member.userId)

const dtoForMembers = (groupUsers: UserProfile[], allUsers: UserProfile[]) => 
    groupUsers
        //@ts-ignore
        .map(member => allUsers.find(x => x.id === member.userId))
        .filter(x => x) as UserProfile[]
